import "./dropdownCategories.scss";

import React, { useEffect, useRef, useState } from "react";

import { Link } from "gatsby";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

function DropdownCategories(props: ReferenciaContenido) {
  const items = props?.referenciaPlantillaContenido;
  const dropdownTitle = props?.tituloGeneral;

  const activatorRef = useRef(null);
  //   const dropdownListRef = useRef(null);
  const dropdownWrapperRef = useRef(null); // Nuevo ref para el contenedor del menú
  const [isOpen, setIsOpen] = useState(false);
  const [currentSubmenu, setCurrentSubmenu] = useState(null);

  const keyHandler = (event) => {
    if (event.key === "Escape" && isOpen) {
      setIsOpen(false);
    }
  };

  const closeSubMenu = () => {
    setCurrentSubmenu(null);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  //   useEffect(() => {
  //     if (isOpen && !!items) {
  //       dropdownListRef?.current?.querySelector("a")?.focus();
  //     }
  //   }, [isOpen]);

  return (
    <div
      className={"m-dropdown__Categories-wrapper"}
      onKeyUp={keyHandler}
      onMouseLeave={closeMenu}
      ref={dropdownWrapperRef}
    >
      <button
        className={"m-dropdown__Categories-activator"}
        aria-haspopup="true"
        aria-controls={dropdownTitle}
        ref={activatorRef}
        onMouseEnter={() => setIsOpen(true)}
        //   onClick={() => setIsOpen(true)} //TODO: if the requirement is different it will be use
      >
        {dropdownTitle}
        {""}
        {!!items &&
          (isOpen ? (
            <svg
              height="24"
              fill="#b7bad1"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m0 0h24v24h-24z" fill="none" />
              <path d="m7.41 15.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6z" />
            </svg>
          ) : (
            <svg
              height="24"
              fill="#b7bad1"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m0 0h24v24h-24z" fill="none" />
              <path d="m7.41 8.59 4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
            </svg>
          ))}
      </button>
      {!!items && (
        <ul
          //  ref={dropdownListRef}
          className={`${"m-dropdown__Categories-item__list"} ${
            isOpen || currentSubmenu ? " active" : ""
          } `}
          data-testid="dropdown-list"
        >
          {items?.map((item, index) => {
            return (
              <li
                className={"m-Categories__item-list"}
                key={index}
                onMouseLeave={closeSubMenu}
              >
                <Link to={item.redireccionBoton}>{item.tituloDescripcion}</Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default DropdownCategories;
